import APIRequestState from './_util/api-request';

/** body: {email} */
class SubscribeState extends APIRequestState {
  get method() { return 'POST'; }
  get url() { return '/users/acceptMarketing'; }
}

export default SubscribeState;



// WEBPACK FOOTER //
// ./spa/state/subscribe.jsx